export default __webpack_public_path__ + "static/Pregnant-Woman-Relaxing-With-Tea-Desktop-@2x-9a77f1f54a85004b7046cb08e35818e8.jpg";